import {gql} from 'apollo-angular';

export const GET_GAME_JS_SCHOOL_CLASS = gql`
  query GetGameJrSchoolClass($schoolClassId: Int!) {
    getGameJRSchoolClass(schoolClassID: $schoolClassId) {
      id
      jobs {
        id
        name
        nameDisplayed
        avatarImage {
          medium {
            url
            width
          }
        }
        jobImage {
          medium {
            url
            width
          }
        }        
      }
      lastJob {
        id
        name
      }
      lastStep
    }
  }
`;
